import ImportRecords from './import-records.js';


export default class ImportSubusers extends ImportRecords {


	constructor(params = {})
	{
		const defaults = { 
			container:   '.import-subusers',
			contents:    '.subuser-list',
			cached_key:  'queued-subusers',
			spinner_msg: 'Importing sub users...please wait',
			ajax_path:   '/admin/import/users/sub/partials'
		}

		var p = { ...defaults, ...params };

		super(p);
	}


}